<div class="logo-container">
	<div class="msp-logo"><img src="assets/images/logo/msp-blue/logo_{{ darkMode ? 'dark' : 'light' }}_horizontal_desc.svg" /></div>
	<div class="semantix-logo">
		<span>POWERED BY</span>
		<img src="assets/images/logo/logo_{{ darkMode ? 'dark' : 'light' }}_semantix.svg" />
	</div>
</div>
